import React from "react";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

import IntroBreakdownModule from "./introBreakdown";
import NoVisitAfterFirstVisitModule from "./noVisitAfterFirstVisit";
import HeatmapModule from "./heatmap";
import IntroConversion from "./introConversion";

const pageConfig = {
  pageName: "Retention",
  configuratorWidth: { dark: 470, light: 380 },
  moduleList: [IntroBreakdownModule, NoVisitAfterFirstVisitModule, HeatmapModule, IntroConversion]
};

const RetentionPage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default RetentionPage;
